@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.rate-shopper-cell {
  display: flex;
  align-items: center;
}

.icon-wrapper {
  height: 30px;
  width: 20px;
  min-width: 20px;
  align-self: center;
  position: relative;
}

.error-icon {
  color: @grid--error-icon--text-color;
  vertical-align: middle;
  height: 15px;
  padding-bottom: 4px;
}

.shopper-template {
  line-height: 1.3;
  margin-top: 3px;
}
